import {initializeApp} from "firebase/app";
import {getAuth} from "firebase/auth";
import {getDatabase} from "firebase/database";

// Remplacer par vos propres configurations Firebase
const firebaseConfig = {
    apiKey: "AIzaSyCx6Q_jaKvK7J6VxVoOaQoh210ilWzVZT8",
    authDomain: "jeesim-registry.firebaseapp.com",
    projectId: "jeesim-registry",
    storageBucket: "jeesim-registry.firebasestorage.app",
    messagingSenderId: "658173792724",
    appId: "1:658173792724:web:3e0de56ed07e528e438641",
    measurementId: "G-KQH3SR88YH"
};
// Initialiser Firebase
const app = initializeApp(firebaseConfig);

// Exporter les services
const auth = getAuth(app);
const database = getDatabase(app);
export {app, auth, database,};
